<script setup lang="ts">
import { useRouter, useRoute } from 'vue-router'
import { useUserStore } from '@/stores/user'
import { ScanMode } from '@/models/Scan'
import FadeTransition from '@/components/FadeTransition.vue'

const router = useRouter()
const route = useRoute()

const userStore = useUserStore()
const user = userStore.authenticatedUser

const hasHistory = () => window.history.length > 2
const back = () => (hasHistory() && route.name !== 'home' ? router.back() : router.replace('/'))
const logout = () => userStore.logout()
</script>

<template>
  <header>
    <img class="logo" src="@/assets/images/header-logo.svg" alt="Logo OPALA" />
    <FadeTransition>
      <a
        class="logout left"
        @click="logout"
        v-if="route.name === 'home'"
      >
        <img src="../assets/logout.svg" alt="Se déconnecter" />
      </a>
      <a class="back left" @click="back">
        <img src="../assets/back.svg" alt="Retour" />
      </a>
    </FadeTransition>
    <RouterLink class="incident right" :to="{ name: 'report-incident' }">
      <img
        src="../assets/warning-active.svg"
        alt="Signaler un incident"
        v-if="route.name.indexOf('report-incident') > -1"
      />
      <img src="../assets/warning.svg" alt="Signaler un incident" />
    </RouterLink>
  </header>
</template>

<style scoped lang="scss">
header {
  padding-top: 2.5dvh;
  text-align: center;
  background-image: url('@/assets/images/header-background.svg');
  background-repeat: no-repeat;
  background-position-x: center;
  background-position-y: -2dvh;
  background-size: 100% auto;
  position: relative;

  img.logo {
    width: 52.5%;
    max-width: 200px;
  }

  a {
    &.left {
      left: 5%;
    }
    &.right {
      right: 5%;
    }

    &.back {
      position: absolute;
      top: 60%;
      width: 4.25dvh;
      height: 4.25dvh;
    }

    &.logout,
    &.incident {
      position: absolute;
      top: 60%;
      right: 5%;
    }
    &.logout {
      width: 4.25dvh;
      height: 4.25dvh;
    }
    &.incident {
      width: 5dvh;
      height: 5dvh;
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}

@media screen and (min-aspect-ratio: 0.62) {
  header {
    background-position-y: bottom;
  }
}
</style>
